// ============================================
// FILE 4: /frontend/src/api/chama.api.js
// PURPOSE: Chama API endpoints for shares model
// CHANGES: Updated to match new shares-based endpoints
// ============================================

import apiClient from './client.js';

export const chamaAPI = {
  // Get shares info for a listing
  getSharesInfo: async (listingId) => {
    const response = await apiClient.get(`/chama/shares/${listingId}`);
    return response.data;
  },

  // Submit shares interest
  submitSharesInterest: async (interestData) => {
    const response = await apiClient.post('/chama/interest', interestData);
    return response.data;
  },

  // Confirm deposit paid
  confirmDepositPaid: async (interestId, paymentReference) => {
    const response = await apiClient.post(`/chama/${interestId}/deposit`, {
      paymentReference
    });
    return response.data;
  },

  // Approve/decline deposit (admin)
  approveDeposit: async (interestId, approved, adminNotes = '') => {
    const response = await apiClient.post(`/chama/${interestId}/approve-deposit`, {
      approved,
      adminNotes
    });
    return response.data;
  },

  // Get interests for a listing
  getChamaInterests: async (listingId) => {
    const response = await apiClient.get(`/chama/listing/${listingId}`);
    return response.data;
  },

  // Get user's chama interests
  getUserChamaInterests: async (userId) => {
    const response = await apiClient.get(`/chama/user/${userId}`);
    return response.data;
  },

  // Get all chama interests (admin)
  getAllChamaInterests: async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const response = await apiClient.get(`/chama?${queryString}`);
    return response.data;
  },

  // Update interest status (admin)
  updateChamaInterestStatus: async (interestId, status, adminNotes = '') => {
    const response = await apiClient.patch(`/chama/${interestId}/status`, {
      status,
      adminNotes
    });
    return response.data;
  },
};